export const ActiveMessageSettingsConstants = {
    //Translate constants
    LEGEND_REQ: 'attendance-settings.activeMessages.requirementModal.legend.',
    ESSENTIAL_REQ: 'attendance-settings.activeMessages.requirementModal.essentialReq.',
    RECOMMENDED_REQ: 'attendance-settings.activeMessages.requirementModal.recommendedReq.',
    ROUTER_CONFIG: 'attendance-settings.activeMessages.routerConfig.validation.',
    TXT_TITLE: 'title',
    TXT_LINK: 'Link',
    TXT_WHATSAPP_CHANNEL_CONNECTED: 'whatsAppChannelConnected',
    TXT_HUMAN_FLOW_STATE: 'humanFlow',
    TXT_MESSAGE_TEMPLATE_AT_WHATSAPP: 'messageTemplateAtWhatsApp',
    TXT_MESSAGE_TEMPLATE_ENABLED_AT_BLIP: 'messageTemplateEnabledAtBlip',
    TXT_LEGEND_CONFIGURED: 'checkball',
    TXT_LEGEND_NOT_CONFIGURED: 'warning',
    TXT_LEGEND_ERROR: 'error',
    // Router identity Reason Codes
    OWNER_DOES_NOT_BELONG_SAME_ORGANIZATION_THE_OWNER_IMPERSONATED: 5,
    ROUTER_DOES_NOT_BELONG_TO_AN_ORGANIZATION: 9,
    ROUTER_NOT_FOUND: 10,
    IDENTITY_DOES_NOT_HAS_WHATSAPP_CONNECTED: 11,
    ROUTER_VALIDATION_ERROR: 12,
    ROUTER_AND_CHATBOT_ARE_THE_SAME: 13,
    ID_IS_NOT_A_ROUTER: 14,
    // router identity translate
    DIFFERENT_TENANT: 'differentTenant',
    INVALID_ROUTERID: 'invalidRouterId',
    NO_WHATSAPP_CHANNEL_CONNECTED: 'noWhatsAppChannelConected',
    ROUTER_ID_MUST_BE_DIFFERENT_THAN_CHATBOT: 'routerIdMustBeDifferentThanChatbot',
    ROUTERBOT_HAVE_NO_TENANT: 'routerDoesNotHaveTenant',
    ID_INFORMED_IS_NOT_A_ROUTER: 'idInformedIsNotARouter',
    ERROR: 'error',
    // Settings code
    WHATSAPP_CHANNEL_CONNECTED: 'WhatsAppChannelConnected',
    HUMAN_FLOW_STATE: 'HumanFlowState',
    MESSAGE_TEMPLATE_AT_WHATSAPP: 'MessageTemplateAtWhatsApp',
    MESSAGE_TEMPLATE_ENABLED_AT_BLIP: 'MessageTemplateEnabledAtBlip',
    // Settings status
    CONFIGURED: 'Configured',
    NOT_CONFIGURED: 'NotConfigured',
    Error: 'Error',
    DOMAIN_MSG: '@msging.net',
    // Regexs
    REGEX_IS_VALID_IDENTITY: /^[a-zA-Z0-9@.]+$/,
};
